import * as React from 'react';

export interface SelectedProductContextValue {
  selectedItemNumber?: string;
  setSelectedItemNumber: (itemNumber?: string) => void;
}

export const SelectedProductContext = React.createContext<SelectedProductContextValue>({
  selectedItemNumber: undefined,
  setSelectedItemNumber: () => undefined,
});

export const SelectedProductProvider: React.FunctionComponent = ({children}) => {
  const [selectedItemNumber, setSelectedItemNumber] = React.useState<string>();

  return (
    <SelectedProductContext.Provider value={{selectedItemNumber, setSelectedItemNumber}}>
      {children}
    </SelectedProductContext.Provider>
  );
};

export const useSelectedProduct = (): SelectedProductContextValue => React.useContext(SelectedProductContext);
